<template>
	<app-button icon="plus" size="small" @click="open = true">Add Sub Group</app-button>

	<slideover title="Add Sub Group" :open="open" @close="close">
		<div class="mb-4 flex flex-col gap-4">
			<app-input
				v-model="searchForm.code"
				label="Code"
				name="code"
				placeholder="Search by code..." />
			<app-input
				v-model="searchForm.name"
				label="Name"
				name="name"
				placeholder="Search by name..." />
			<app-input
				v-model="searchForm.pgroup"
				label="PGROUP"
				name="pgroup"
				placeholder="Search by pgroup..." />

			<app-button :disabled="isLoading" class="mt-3" @click="searchSubGroups">
				<span v-if="isLoading">Loading...</span>
				<span v-else>Search</span>
			</app-button>

			<div v-if="subGroups.length > 0" class="mt-4">
				<sub-groups-table
					v-model:selected="selectedSubGroups"
					:subgroups="subGroups"
					:loading="isLoading" />
			</div>

			<div v-else-if="hasSearched && !isLoading" class="mt-2 text-sm text-gray-500">
				No results found.
			</div>
		</div>

		<template #action>
			<div class="flex justify-end w-full">
				<app-button :disabled="selectedSubGroups.length === 0" @click="submit"
					>Save</app-button
				>
			</div>
		</template>
	</slideover>
</template>

<script lang="ts" setup>
	import { ref, reactive } from 'vue'
	import useToaster from '@/stores/toaster'
	import ProductService from '@/services/product'
	import SubgroupService from '@/services/subgroup'
	import SubGroupsTable from '@/components/datatables/all/SubGroupsTable.vue'

	const toaster = useToaster()

	const submitting = ref<boolean>(false)
	const open = ref(false)
	const subGroups = ref<any[]>([])
	const isLoading = ref(false)
	const selectedSubGroups = ref<any[]>([])
	const hasSearched = ref(false)

	const searchForm = reactive({
		name: '',
		code: '',
		pgroup: ''
	})

	const props = defineProps<{
		productId: string
	}>()

	const emit = defineEmits(['completed'])

	function close() {
		open.value = false
		selectedSubGroups.value = []
		subGroups.value = []
		searchForm.name = ''
		searchForm.code = ''
		searchForm.pgroup = ''
		hasSearched.value = false
	}

	const submit = () => {
		if (selectedSubGroups.value.length === 0) return

		submitting.value = true
		const productService = new ProductService()

		const subgroups = selectedSubGroups.value.map((group) => group.subgroup)

		productService
			.addSubGroup(props.productId, {
				subgroups: subgroups
			})
			.then(() => {
				toaster.success({ text: 'Sub groups added successfully' })
				close()
				emit('completed')
			})
			.finally(() => {
				submitting.value = false
			})
	}

	const searchSubGroups = () => {
		subGroups.value = []
		selectedSubGroups.value = []
		isLoading.value = true
		hasSearched.value = true
		const subgroupService = new SubgroupService()

		const params: any = {}
		if (searchForm.name) params.name = searchForm.name
		if (searchForm.code) params.code = searchForm.code
		if (searchForm.pgroup) params.pgroup = searchForm.pgroup

		subgroupService
			.getAll(params)
			.then((response) => {
				subGroups.value = response.data.data.map((sg: any) => ({
					subgroup: sg.code,
					name: sg.name,
					pgroup: sg.group
				}))
			})
			.finally(() => {
				isLoading.value = false
			})
	}
</script>
